'use strict';

var _ = require('lodash');
var d3 = require('d3');
var Scales = function Scales(params, data, barSpaceWidth, metricKey, mainScale) {
  var BAR_MIN_WIDTH = 40;
  var servicesMetricData = _.map(data, metricKey);
  var dataWithoutGaps = _.filter(data, ['isGap', false]);
  var yMin = d3.min(dataWithoutGaps, function (d) {
    return Math.min(d[metricKey], 0);
  });
  var yMax = d3.max(dataWithoutGaps, function (d) {
    return Math.max(d[metricKey], 0);
  });
  if (mainScale) {
    if (yMax === yMin) {
      yMax = yMin + params.yNumberOfTicks - 1;
    }
    var mainScaleDomain = mainScale.yScale.domain();
    var mainYMax = mainScaleDomain[1];
    var mainYMin = mainScaleDomain[0];
    if (mainYMax !== 0) {
      yMin = mainYMin * yMax / mainYMax;
    }
  }
  var dataBarsWidth = barSpaceWidth * data.length;
  var xMax = dataBarsWidth > params.width ? dataBarsWidth : params.width;
  var x = d3.scale.ordinal().domain(_.map(data, 'displayServiceIdKey')).range(servicesMetricData.map(function (element, index) {
    return 5 + barSpaceWidth * index;
  }).concat([0, xMax]));
  x.rangeBand = function () {
    return BAR_MIN_WIDTH;
  };
  x.rangeExtent = function () {
    return [2, dataBarsWidth];
  };
  x.linesRange = function () {
    return [-20, xMax];
  };
  var y = d3.scale.linear().domain([yMin, yMax]).rangeRound([params.height, 0]);
  return {
    xScale: x,
    yScale: y
  };
};
Scales.$inject = [];
module.exports = Scales;